var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVisionPlay(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 32,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.25 41.0001C25.0511 41.0001 24.8603 40.921 24.7197 40.7804C24.579 40.6397 24.5 40.449 24.5 40.2501V23.7501C24.5 23.6197 24.5339 23.4916 24.5985 23.3784C24.6631 23.2652 24.7561 23.1708 24.8682 23.1044C24.9804 23.0381 25.108 23.0021 25.2383 23.0001C25.3686 22.9981 25.4972 23.03 25.6114 23.0928L40.6114 31.3428C40.7291 31.4075 40.8273 31.5027 40.8956 31.6183C40.964 31.7339 41 31.8657 41 32C41 32.1343 40.964 32.2662 40.8956 32.3818C40.8273 32.4974 40.7291 32.5925 40.6114 32.6572L25.6114 40.9072C25.5007 40.9681 25.3764 41 25.25 41.0001Z",
    fill: "#FA541C"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisionPlay);
export default __webpack_public_path__ + "static/media/vision_play.ea6ecba1b4e90623bedaa0d9b46911a3.svg";
export { ForwardRef as ReactComponent };